import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, easeInOut, } from 'framer-motion';
import {
  Calendar, Clock, MapPin, Heart, Users,
  ArrowRight, MessageCircle, Edit2, Trash2, X, Send, Star, Sparkles,
  Music2, Hand, Flame, Cross, AlarmClockCheck, User, Check, AlertCircle, ActivityIcon,
  XCircle, Mail, CheckCircle
} from 'lucide-react';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import '../events/inputStyle.css';
import ImagesDev from '../../api/images';
import { getUserData } from '../../api/authService';
import { Toast } from '../../components/Toast';
import { EventsHighlights } from '../../components/EventsHighlights';
import { RegistrationCounter } from '../../components/RegistrationCounter';
import Volunteer_subComponent from '../events/Volunteer_subComponent';

function HealingParty() {
  const [activeSection, setActiveSection] = useState('about');
  const [activeTestimony, setActiveTestimony] = useState(0);
  const [form, setForm] = useState({
    first_name: "",
    surname: "",
    email_address: "",
    phone_number: "",
    volunteer: "",
    vip: "false",
    isEmailAvailable: false,
    isPhoneValid: false,
  });
  const [registrants, setRegistrants] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isRegistered, setIsRegistered] = useState(false);
  const [closedRegistration, setClosedRegistration] = useState(true);

  const testimonies = [
    {
      quote: "I was healed from my addiction that I had suffered with for 10 years, Just by hearing the word",
      author: "Sarah M.",
      location: "Ghana",
      image: ImagesDev.gallery.lifeInTheSpirit[1]
    },
    {
      quote: "The doctors said it was impossible, but God made it possible",
      author: "John D.",
      location: "Nigeria",
      image: ImagesDev.gallery.lifeInTheSpirit[1]
    },
    {
      quote: "Knowing that Jesus died for me, has healed me from all my insecurities",
      author: "Rachel K.",
      location: "Nigeria",
      image: ImagesDev.gallery.lifeInTheSpirit[1]
    }
  ];


  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTestimony((prev) => (prev + 1) % testimonies.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);


  const fetchRegistrants = async () => {
    const endpoint = 'https://tsoministries.com/wp-json/wp/v2/thp';
    let page = 1;
    let allRegistrants = [];

    try {
      while (true) {
        const response = await fetch(`${endpoint}?per_page=100&page=${page}&_fields=id,email_address`);

        if (!response.ok) {
          // If we've hit an invalid page number, assume we're done
          if (response.status === 400 && page > 1) break;
          throw new Error(`Error fetching page ${page}`);
        }

        const data = await response.json();

        if (!Array.isArray(data) || data.length === 0) break;

        allRegistrants = [...allRegistrants, ...data];
        if (data.length < 100) break; // No more full pages
        page++;
      }

      setRegistrants(allRegistrants);
    } catch (error) {
      console.error('Failed to fetch registrants:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {

    fetchRegistrants()

    setTimeout(() => {
      // setRegistrants({length: 1244})
    }, 2000);
  }, []);

  const totalRegistered = registrants.length;
  const maxCapacity = (() => {
    if (totalRegistered <= 100) return 500;
    if (totalRegistered <= 200) return 500;
    if (totalRegistered <= 249) return 500;
    if (totalRegistered <= 299) return 500;
    if (totalRegistered <= 349) return 500;
    if (totalRegistered <= 399) return 500;
    if (totalRegistered <= 449) return 500;
    if (totalRegistered <= 499) return 500;
    if (totalRegistered <= 549) return 550;
    if (totalRegistered <= 599) return 600;
    if (totalRegistered <= 649) return 650;
    if (totalRegistered <= 699) return 700;
    if (totalRegistered <= 749) return 750;
    if (totalRegistered <= 799) return 800;
    const calculated = Math.ceil(totalRegistered * 1.4);
    return Math.ceil(calculated / 10) * 10;
  })();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (form.isEmailAvailable === false) {
      Toast.error('Email is already in use. Please use another email.');
      setIsSubmitting(false);
      return;
    }

    if (form.isEmailAvailable === null) {
      Toast.error('Unable to verify email. Please check your connection and try again.');
      setIsSubmitting(false);
      return;
    }

    if (!form.isPhoneValid) {
      Toast.error('Your Phone number is not valid.');
      setIsSubmitting(false);
      return;
    }

    // Proceed to submit
    try {
      const response = await fetch("https://tsoministries.com/wp-json/custom-form/v1/thp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const result = await response.json();
      if (response.ok) {
        sendEmail([{ id: 1600, email_address: form.email_address }]);
        fetchRegistrants()
        setTimeout(() => {
          Toast.success("Registration successful! We'll be in touch soon.");
          setIsSubmitting(false);
          setIsRegistered(true);
        }, 2000);
        // setForm({
        //     first_name: "",
        //     surname: "",
        //     email_address: "",
        //     phone_number: "",
        //     isEmailAvailable: null,
        //     isPhoneValid: false,
        // });
      } else {
        Toast.success("Something went wrong, Please post this issue in our issues page");
        setTimeout(() => {
          setIsSubmitting(false);
          throw new Error(result.message || 'Something went wrong');
        }, 600);
      }
    } catch (error) {
      Toast.error(error.message || 'Failed to submit form');
      setIsSubmitting(false);
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 2000);
    }
  };

  const handleSubmit____ = () => {
    setIsRegistered(true)
  }

  const sendEmail = async (registrants) => {
    for (const registrant of registrants) {
      try {
        const res = await fetch('https://tsoministries.com/wp-json/custom-api/v1/send-thp-invite', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(registrant),
        });

        if (!res.ok) throw new Error(`Failed to send to ${registrant.email_address}`);
        // setSent(prev => [...prev, registrant]);
      } catch (err) {
        console.error(err);
        // setFailed(prev => [...prev, registrant]);
      }
    }
  };

  const upcomingEvents = [
    {
      date: "November 30, 2024",
      time: "10:00 AM",
      location: "Shekinah Avenue Auditorium, Accra.",
      theme: "The Healing Party - Ghana",
      image: ImagesDev.hpGImg,
      description: "Experience divine healing in an atmosphere of faith and expectation"
    },
    {
      date: "Augus 10, 2024",
      time: "10:00 AM",
      location: "Christ The Dayspring Church, Ibadan.",
      theme: "The Healing Party - Ibadan",
      image: ImagesDev.thpImg,
      description: "Join us for a powerful night of miracles and testimonies"
    }
  ];

  const features = [
    {
      icon: Heart,
      title: "Divine Healing",
      description: "Experience God's supernatural healing power",
      color: "text-red-400",
      gradient: "from-red-600/20 to-red-900/20",
      border: "border-red-500/20"
    },
    {
      icon: Users,
      title: "Prayer Support",
      description: "Dedicated team of prayer warriors",
      color: "text-blue-400",
      gradient: "from-blue-600/20 to-blue-900/20",
      border: "border-blue-500/20"
    },
    {
      icon: Music2,
      title: "Worship Atmosphere",
      description: "Spirit-led worship experience",
      color: "text-purple-400",
      gradient: "from-purple-600/20 to-purple-900/20",
      border: "border-purple-500/20"
    },
    {
      icon: Hand,
      title: "Faith Building",
      description: "Strengthen your faith through testimonies",
      color: "text-amber-400",
      gradient: "from-amber-600/20 to-amber-900/20",
      border: "border-amber-500/20"
    }
  ];

  return (
    <div
      className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white pt-0"
    >
      {/* New Hero Section */}
      <div className="relative min-h-screen">
        {/* Animated Background */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-red-900/30 via-amber-900/30 to-purple-900/30" />
          <img
            src={ImagesDev.gallery.healingParty[0]}
            alt="Healing Party"
            className="absolute w-full h-full object-cover opacity-[0.1]"
          />
          {/* <div className="absolute inset-0">
            {Array.from({ length: 50 }).map((_, i) => (
              <div
                key={i}
                className="absolute rounded-full bg-white/20 blur-xl"
                style={{
                  width: `${Math.random() * 400 + 100}px`,
                  height: `${Math.random() * 400 + 100}px`,
                  top: `${Math.random() * 100}%`,
                  left: `${Math.random() * 100}%`,
                  animation: `float ${Math.random() * 10 + 10}s linear infinite`,
                  animationDelay: `${Math.random() * 10}s`
                }}
              />
            ))}
          </div> */}
        </div>

        <div className="relative container mx-auto px-3 md:px-10">
          {/* Split Hero Layout */}
          <div className="grid md:grid-cols-2 gap-12 items-center min-h-screen">
            {/* Left Content */}
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.5 }}
              className="space-y-8"
            >
              <div className="inline-flex items-center space-x-2 bg-white/10 rounded-full px-4 py-2 mt-[10vh] sm:mt-0 backdrop-blur-sm opacity-0 md:opacity-100 animate-pulse">
                <Flame className="w-5 h-5 text-orange-400" />
                <span className="text-sm">Next Event: 28th August, 2026</span>
              </div>

              <h1 className="text-5xl md:text-7xl font-bold leading-tight">
                The
                <span className="block mt-2 text-transparent bg-clip-text bg-gradient-to-r from-red-400 via-amber-400 to-orange-400">
                  Healing Party
                </span>
              </h1>

              <div>
                <p className="text-xl text-gray-300">
                  Experience miraculous healing in an atmosphere charged with faith, worship, and divine presence
                </p>
                <p className='text-[6px] mt-1'>
                  #TitoTheWriter, #TSO-Ministries, #BST
                </p>
                <p className='text-[6px] mt-1'>
                  #bible-study-with-titoluwa #Healing-Party #BST
                </p>
              </div>

              <div className="flex flex-wrap gap-4">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => window.location.href = "/healing-party/#register"}
                  className="px-8 py-3 bg-gradient-to-r from-red-500 via-amber-500 to-orange-500 text-white rounded-full hover:from-red-600 hover:to-orange-600 transition-colors shadow-lg"
                >
                  Register Now
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => window.location.href = "/healing-party/#about"}
                  className="px-8 py-3 bg-white/10 text-white rounded-full hover:bg-white/20 transition-colors backdrop-blur-sm"
                >
                  Read More
                </motion.button>
              </div>


              {/* Quick Stats */}
              {/* <div className="grid grid-cols-2 gap-4 mt-12">
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-red-500/20 rounded-lg">
                      <Hand className="w-6 h-6 text-red-400" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold">1000+</h3>
                      <p className="text-sm text-gray-400">Healings Recorded</p>
                    </div>
                  </div>
                </div>
                <div className="bg-white/5 backdrop-blur-sm rounded-xl p-4 border border-white/10">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-amber-500/20 rounded-lg">
                      <Cross className="w-6 h-6 text-amber-400" />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold">5+</h3>
                      <p className="text-sm text-gray-400">Countries Reached</p>
                    </div>
                  </div>
                </div>
              </div> */}
            </motion.div>

            {/* Right Content - Floating Testimony Cards */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.8 }}
              className="relative aspect-[4/4] md:aspect-[4/5] md:block flex justify-center items-center bg-black overflow-hidden rounded-3xl mb-8 md:mb-0"
            >
              <img
                // src={ImagesDev.gallery.healingParty[1]}
                src={"https://tsoministries.com/wp-content/uploads/2026/08/THP26-Updated-scaled.png"}
                alt="Healing Party"
                className="relative w-full h-full object-cover"
              />

              {/* RETURN THIS SECTION AFTER THE EVENT */}
              {/* {testimonies.map((testimony, index) => (
                <motion.div
                  key={index}
                  initial={false}
                  animate={{
                    scale: activeTestimony === index ? 1 : 0.8,
                    y: activeTestimony === index ? 0 : 20,
                    opacity: activeTestimony === index ? 1 : 0.3,
                    zIndex: activeTestimony === index ? 20 : 10,
                  }}
                  transition={{ duration: 0.5 }}
                  className="absolute top-1/2 left-[11%] transform -translate-x-1/2 -translate-y-1/2 w-[80%] backdrop-blur-md "
                >
                  <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
                    <div className="flex items-start gap-4">
                      <img
                        src={testimony.image}
                        alt={testimony.author}
                        className="w-12 h-12 rounded-full object-cover"
                      />
                      <div>
                        <blockquote className="text-lg mb-4">"{testimony.quote}"</blockquote>
                        <div className="flex items-center gap-2 text-sm text-gray-400">
                          <span className="font-medium text-white">{testimony.author}</span>
                          <span>•</span>
                          <span>{testimony.location}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))} */}
            </motion.div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        >
          <div className="w-6 h-10 rounded-full border-2 border-white/20 flex items-start justify-center p-2">
            <div className="w-1 h-2 bg-white/60 rounded-full" />
          </div>
        </motion.div>
      </div>

      {/* Scripture Section */}
      <div className="py-24 bg-gradient-to-b from-black/50 to-red-900/20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-4xl font-serif italic mb-6">
                "He sent out his word and healed them; he rescued them from the grave."
              </h2>
              <p className="text-xl text-gray-400">Psalm 107:20</p>
            </motion.div>
          </div>
        </div>
      </div>

      <OldRegistrationSection
        isRegistered={isRegistered} form={form} handleSubmit={handleSubmit} handleChange={handleChange}
        setForm={setForm} isSubmitting={isSubmitting} totalRegistered={totalRegistered} closedRegistration={closedRegistration}
        maxCapacity={maxCapacity}
      />


      <div className="container mx-auto px-4 py-12">
        {/* Features Section */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-24 md:px-16">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`bg-gradient-to-br ${feature.gradient} p-8 rounded-2xl backdrop-blur-sm border ${feature.border}`}
            >
              <feature.icon className={`w-12 h-12 ${feature.color} mb-6`} />
              <h3 className="text-lg md:text-2xl font-bold mb-4">{feature.title}</h3>
              <p className="text-sm md:text-md text-gray-300">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        {/* About Section */}
        <div id='about' className="grid md:grid-cols-2 gap-12 mb-24 md:px-10">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl font-bold mb-6">About Healing Party</h2>
            <div className="prose prose-lg prose-invert">
              <p className="text-xl leading-relaxed text-gray-300 mb-6">
                The Healing Party is a unique move of God where Christ alone is taught, worshipped,
                spoken of and as a result, miracles and signs take place.The Healing Party is Hosted by Pastor
                TitOluwa Olumideko, it seeks to highlight and celebrate the over-completeness of God
                and His Word as bringing whatever healing needed to the souls of men!
              </p>
              <p className="text-xl leading-relaxed text-gray-300">
                It is a divine atmosphere where healing flows, lives are changed and God's power is real. This year's edition carries even more fire, glory and transformation.
              </p>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative h-full min-h-[400px] rounded-2xl overflow-hidden"
          >
            <img
              src={"https://tsoministries.com/wp-content/uploads/2025/09/B_H00805-scaled.jpeg"}
              alt="Healing Service"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-8">
              <blockquote className="text-2xl font-serif italic text-white">
                "With God, all things are possible"
              </blockquote>
              <p className="text-gray-300 mt-2">- Matthew 19:26</p>
            </div>
          </motion.div>
        </div>

        {/* Events */}
        {/* <div id='all-events' className="mb-24">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4">Recent Events</h2>
            <p className="text-xl text-gray-400">Join us at our next healing service</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 md:mx-10">
            {upcomingEvents.map((event, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.2 }}
                className="group relative overflow-hidden rounded-2xl bg-white/5 backdrop-blur-sm border border-white/10"
              >
                <div className="aspect-video relative overflow-hidden">
                  <img
                    src={event.image}
                    alt={event.theme}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
                </div>

                <div className="p-8">
                  <h3 className="text-2xl font-bold mb-2">{event.theme}</h3>
                  <p className="text-gray-300 mb-6">{event.description}</p>
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div className="space-y-2 text-gray-300">
                      <div className="flex items-center gap-2">
                        <Calendar className="w-4 h-4 text-red-400" />
                        <span>{event.date}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <Clock className="w-4 h-4 text-red-400" />
                        <span>{event.time}</span>
                      </div>
                    </div>
                    <div className="space-y-2 text-gray-300">
                      <div className="flex items-center gap-2">
                        <MapPin className="w-4 h-4 text-red-400" />
                        <span>{event.location}</span>
                      </div>
                    </div>
                  </div>
                  <motion.button
                    whileHover={{ x: 5 }}
                    className="flex items-center gap-2 text-red-400 hover:text-red-300 transition-colors"
                    onClick={() => window.location.href = "/gallery"}
                  >
                    Register Now
                    <ArrowRight className="w-4 h-4" />
                  </motion.button>
                </div>
              </motion.div>
            ))}
          </div>
        </div> */}

        {/* Event Highlights */}
        <EventsHighlights parent={"the_healing_party-ghana"} />

        {/* Testimonials */}
        <HealingPartyComments />
      </div>
    </div>
  );
}




const OldRegistrationSection = ({ isRegistered, form, handleSubmit, handleChange, setForm, isSubmitting, totalRegistered, closedRegistration, maxCapacity }) => {
  return (
    <>
      {/* Registration Section */}
      <div id='register' className="relative py-10 pt-16 bg-gradient-to-b from-gray-950/20 to-transparent bg-gray-900">
        <div className="absolute top-0 left-0 w-full h-full opacity-5 rounded-xl overflow-hidden">
          <img
            src={"https://tsoministries.com/wp-content/uploads/2025/07/thp_new.jpeg"}
            alt="Walking in Divine Authority Book Cover"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="container mx-auto px-1 md:px-4">
          <div className="grid lg:grid-cols-2 gap-3 md:gap-8 max-w-6xl mx-auto">
            {/* Registration CLOSED */}
            {closedRegistration && <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <form onSubmit={handleSubmit} className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-pink-300/10 h-full flex flex-col justify-center items-center">
                <h2 className="text-3xl font-bold mb-0 text-cente">Registration is closed!</h2>
                <p className="text-xl mb-6 text-center"> Registration for The Healing Party is closed, Visit the Gallery to view Highlights</p>
                <div className='w-[150px] h-[150px] bg-white/10 rounded-full flex justify-center items-center'>
                  <AlarmClockCheck className='w-[100px] h-[100px] text-orange-500' />
                </div>
              </form>
            </motion.div>}

            {/* Registered successful Notice */}
            {(!closedRegistration && isRegistered) && <Volunteer_subComponent email_address={form.email_address} phone_number={form.phone_number} />}

            {/* Form Fields */}
            {(!closedRegistration && !isRegistered) && <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <form onSubmit={handleSubmit} className="relative bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-red-300/10">
                <h2 className="text-2xl font-bold mb-1">Register Now</h2>
                <p className="text-sm mb-6">This Registration is for attendees</p>
                <div className="space-y-6">
                  {/* Form fields... */}
                  <div>
                    <label className="block text-sm font-medium mb-2">First Name</label>
                    <div className="relative">
                      <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                      <input
                        type="text"
                        name="first_name"
                        value={form.first_name}
                        onChange={handleChange}
                        className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-300"
                        required
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-2">Surname</label>
                    <div className="relative">
                      <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                      <input
                        type="text"
                        name="surname"
                        value={form.surname}
                        onChange={handleChange}
                        className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all duration-300"
                        required
                      />
                    </div>
                  </div>



                  {/* Phone Number */}
                  <THPPhoneInput
                    value={form.phone_number}
                    onChange={(e) => handleChange(e)}
                    setForm={setForm}
                  />

                  {/* Email Address */}
                  <THPEmailInput
                    value={form.email_address}
                    onChange={(e) => handleChange(e)}
                    setForm={setForm}
                  />

                  <motion.button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full py-3 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-lg hover:from-red-600 hover:to-red-700 transition-all duration-300 flex items-center justify-center space-x-2"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <span>{isSubmitting ? 'Submitting...' : 'Register Now'}</span>
                  </motion.button>
                </div>

                {/* Loading Modal */}
                <motion.div
                  key={isSubmitting}
                  initial={{ opacity: 0, display: "none" }}
                  animate={isSubmitting === true ? { opacity: 1, display: "flex" } : { opacity: 0, display: "none" }}
                  // whileInView={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, display: "none" }}
                  transition={{ duration: 0.6, ease: easeInOut }}
                  className='absolute h-full w-full bg-black/40 top-0 left-0 rounded-2xl flex flex-col justify-center items-center'
                >
                  <motion.div
                    initial={{ scale: 1 }}
                    animate={{ scale: 1.5 }}
                    transition={{
                      duration: 0.6,
                      ease: easeInOut,
                      repeat: Infinity,
                      repeatType: "reverse",
                    }}
                  >
                    <ActivityIcon size={32} />
                  </motion.div>
                </motion.div>
              </form>
            </motion.div>}

            {/* Registration counter */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <RegistrationCounter
                totalRegistered={totalRegistered}
                maxCapacity={closedRegistration ? totalRegistered : maxCapacity}
                eventDate="August 28, 2026 | 02:00 PM"
                eventLocation="Plot 893, Taiwo Bus Stop, Ogunnusi Road, Beside Road Safety Office, Ojodu-Berger, Lagos."
                theme_active="text-orange-500"
                theme_bg_gradiemt="bg-gradient-to-r from-orange-600 to-orange-700"
                theme_btn_bg="bg-orange-400/10"
                theme_btn_text="text-orange-500"
                className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 h-full"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </>
  )
}

const HealingPartyComments = () => {
  const [comments, setComments] = useState([]);
  const [user, setUser] = useState(null);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageId, setPageId] = useState(null);
  const [showCommentInput, setShowCommentInput] = useState(false);
  const [editingComment, setEditingComment] = useState(null);

  // Fetch Page ID by Slug
  useEffect(() => {
    const fetchPageId = async () => {
      try {
        const response = await fetch(`https://tsoministries.com/wp-json/wp/v2/pages?slug=healing-party`);
        const data = await response.json();
        if (data.length === 0) throw new Error("Page not found");
        setPageId(data[0].id);
      } catch (error) {
        console.error("Error fetching page ID:", error);
      }
    };

    fetchPageId();
  }, []);

  const fetchComments = async () => {
    if (!pageId) return;
    try {
      const response = await fetch(`https://tsoministries.com/wp-json/wp/v2/comments?post=${pageId}`);
      const data = await response.json();
      setComments(data);
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  useEffect(() => {
    if (pageId) {
      fetchComments();
    }
  }, [pageId]);

  useEffect(() => {
    const loadUser = async () => {
      const userData = await getUserData();
      setUser(userData);
    };
    loadUser();
  }, []);

  const submitComment = async () => {
    if (!user || !user.id) return Toast.warning("You must be logged in to comment.");
    if (!comment.trim()) return Toast.warning("Comment cannot be empty.");
    if (!pageId) return Toast.warning("Page ID is not available yet. Please try again.");

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await fetch("https://tsoministries.com/wp-json/wp/v2/comments", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          post: pageId,
          content: comment,
          author: user.id,
        }),
      });

      if (!response.ok) throw new Error("Failed to post comment");

      setComment("");
      setShowCommentInput(false);
      fetchComments();
      Toast.success("Comment posted successfully!");
    } catch (error) {
      console.error("Error posting comment:", error);
      Toast.error("Failed to post comment. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleEditComment = async (commentId) => {
    if (!user || !user.id) return;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`https://tsoministries.com/wp-json/wp/v2/comments/${commentId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify({
          content: editingComment.content,
        }),
      });

      if (!response.ok) throw new Error("Failed to update comment");

      setEditingComment(null);
      fetchComments();
      Toast.success("Comment updated successfully!");
    } catch (error) {
      console.error("Error updating comment:", error);
      Toast.error("Failed to update comment. Please try again.");
    }
  };

  const handleDeleteComment = async (commentId) => {
    if (!user || !user.id) return;

    if (!window.confirm("Are you sure you want to delete this comment?")) return;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`https://tsoministries.com/wp-json/wp/v2/comments/${commentId}`, {
        method: "DELETE",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to delete comment");

      fetchComments();
      Toast.success("Comment deleted successfully!");
    } catch (error) {
      console.error("Error deleting comment:", error);
      Toast.error("Failed to delete comment. Please try again.");
    }
  };

  return (
    <div className="mb-16">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-3xl font-bold">Testimonials</h2>
        {user && (
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => setShowCommentInput(!showCommentInput)}
            className="flex items-center space-x-2 px-4 py-2 bg-orange-600 rounded-lg hover:bg-orange-700 transition-colors"
          >
            <MessageCircle className="w-5 h-5" />
            <span>Share Your Testimony</span>
          </motion.button>
        )}
      </div>

      {/* Comment Input */}
      <AnimatePresence>
        {showCommentInput && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="mb-8"
          >
            <div className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10">
              <div className="flex items-center space-x-4 mb-4">
                <img
                  src={user?.avatar_url || "/default-avatar.png"}
                  alt={user?.name}
                  className="w-10 h-10 rounded-full"
                />
                <div>
                  <p className="font-semibold">{user?.name}</p>
                  <p className="text-sm text-gray-400">Sharing your testimony</p>
                </div>
              </div>
              <textarea
                className="w-full p-4 bg-black/30 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-300 resize-none"
                rows="4"
                placeholder="Share your healing testimony..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
              <div className="flex justify-end space-x-4 mt-4">
                <button
                  onClick={() => setShowCommentInput(false)}
                  className="px-4 py-2 rounded-lg hover:bg-white/10 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={submitComment}
                  disabled={loading}
                  className="flex items-center space-x-2 px-4 py-2 bg-orange-600 rounded-lg hover:bg-orange-700 transition-colors disabled:opacity-50"
                >
                  <Send className="w-4 h-4" />
                  <span>{loading ? "Posting..." : "Post Testimony"}</span>
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Comments Grid */}
      <div className="grid md:grid-cols-3 gap-8">
        {comments.map((comment) => (
          <motion.div
            key={comment.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white/5 backdrop-blur-sm rounded-lg p-6 border border-white/10 relative group"
          >
            <div className="flex items-center space-x-4 mb-4">
              <img
                src={comment.author_avatar_urls?.[48] || "/default-avatar.png"}
                alt={comment.author_name}
                className="w-12 h-12 rounded-full object-cover"
              />
              <div>
                <h3 className="font-bold">{comment.author_name}</h3>
                <p className="text-sm text-gray-400">
                  {new Date(comment.date).toLocaleDateString()}
                </p>
              </div>
            </div>

            {editingComment?.id === comment.id ? (
              <div className="space-y-4">
                <textarea
                  className="w-full p-3 bg-black/30 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                  value={editingComment.content}
                  onChange={(e) => setEditingComment({
                    ...editingComment,
                    content: e.target.value
                  })}
                />
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={() => setEditingComment(null)}
                    className="px-3 py-1 rounded-lg hover:bg-white/10 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleEditComment(comment.id)}
                    className="px-3 py-1 bg-orange-600 rounded-lg hover:bg-orange-700 transition-colors"
                  >
                    Save
                  </button>
                </div>
              </div>
            ) : (
              <div
                className="text-gray-300"
                dangerouslySetInnerHTML={{ __html: comment.content.rendered }}
              />
            )}

            {user && user.id === comment.author && !editingComment && (
              <div className="absolute top-4 right-4 flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() => setEditingComment({
                    id: comment.id,
                    content: comment.content.rendered
                  })}
                  className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
                >
                  <Edit2 className="w-4 h-4" />
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() => handleDeleteComment(comment.id)}
                  className="p-2 bg-white/10 rounded-full hover:bg-white/20 transition-colors"
                >
                  <Trash2 className="w-4 h-4" />
                </motion.button>
              </div>
            )}
          </motion.div>
        ))}
      </div>

      {!user && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-2xl mt-10"
        >
          <div className="absolute inset-0">
            <img
              src="https://images.unsplash.com/photo-1501281668745-f7f57925c3b4"
              alt="Background"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/90 to-black/70 backdrop-blur-sm" />
          </div>

          <div className="relative p-12 md:p-24 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                Have you had an experience at The Healing Party?
              </h2>
              <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
                Share your testimony and inspire others with your story of transformation and faith.
              </p>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => { window.location.href = "/login" }}
                className="px-8 py-3 bg-gradient-to-r from-red-500 to-amber-500 text-white rounded-full hover:from-red-600 hover:to-amber-600 transition-all duration-300 shadow-lg"
              >
                Share Testimony
              </motion.button>
              <p className="text-xs text-gray-300 mt-3 max-w-2xl mx-auto">
                You will be redirected to the login page. 
              </p>
              <p className="text-xs text-gray-300 mb-3 max-w-2xl mx-auto">
                 Come back and share your testimony once you're logged in. 
              </p>
            </motion.div>
          </div>
        </motion.div>
      )}
    </div>
    //     <motion.div
    //     initial={{ opacity: 0, y: 20 }}
    //     animate={{ opacity: 1, y: 0 }}
    //     className="text-center mt-12 bg-white/5 backdrop-blur-sm rounded-lg p-8 border border-white/10"
    //   >
    //     <h2 className="text-3xl font-bold mb-4">Join Us for the Next Healing Party</h2>
    //     <p className="text-xl text-gray-300 mb-8">
    //       Experience the miraculous in an atmosphere of faith and expectation
    //     </p>
    //     <motion.button
    //       whileHover={{ scale: 1.05 }}
    //       whileTap={{ scale: 0.95 }}
    //       className="px-8 py-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-full hover:from-amber-600 hover:to-amber-700 transition-all duration-300 shadow-lg"
    //     >
    //       Register Now
    //     </motion.button>
    //   </motion.div>

  );
};


export default HealingParty





// ---------------------------
// THPPhoneInput component
// ---------------------------
const THPPhoneInput = ({ value, onChange, setForm }) => {
  const [phone, setPhone] = useState(value || "");
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    if (!phone) {
      setIsValid(true);
      setForm((prev) => ({ ...prev, isPhoneValid: false }));
      return;
    }

    const valid = isValidPhoneNumber(phone);
    setIsValid(valid);

    setForm((prev) => ({ ...prev, isPhoneValid: valid }));
  }, [phone, setForm]);

  const handleChange = (value) => {
    setPhone(value);
    onChange({ target: { name: "phone_number", value } });
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium mb-2">Phone Number</label>
      <div className="relative">
        <PhoneInput
          international
          defaultCountry="NG" // Nigeria by default
          value={phone}
          onChange={handleChange}
          className="w-full pl-5 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300"
        />
        {phone && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            {isValid ? (
              <CheckCircle className="text-green-500 w-5 h-5" />
            ) : (
              <XCircle className="text-red-500 w-5 h-5" />
            )}
          </div>
        )}
      </div>

      {!isValid && phone?.length > 0 && (
        <p className="text-red-500 text-sm mt-1">
          Invalid phone number, make sure your number is in the correct format +234 809 999 9999
        </p>
      )}
    </div>
  );
};

// ---------------------------
// THPEmailInput component
// ---------------------------
const THPEmailInput = ({ value, onChange, setForm }) => {
  const [email, setEmail] = useState(value || "");
  const [isValid, setIsValid] = useState(true);
  const [isAvailable, setIsAvailable] = useState(null);
  const [showEmailWarning, setShowEmailWarning] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!email) {
      setIsValid(true);
      setIsAvailable(null);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid = emailRegex.test(email);
    setIsValid(isEmailValid);
    setShowEmailWarning(true);

    if (!isEmailValid) {
      setIsAvailable(null);
      return;
    }

    const delay = setTimeout(async () => {
      setLoading(true);
      try {
        const available = await checkEmailAvailability(email);
        setIsAvailable(available);
      } catch (error) {
        console.error("Error checking email availability:", error);
        setIsAvailable(null); // Force null on any error
      } finally {
        setLoading(false);
      }
    }, 500);

    return () => clearTimeout(delay);
  }, [email]);

  // Always update parent form with current email availability
  useEffect(() => {
    if (!email) {
      setForm(prev => ({ ...prev, isEmailAvailable: null }));
      return;
    }

    if (isValid) {
      setForm(prev => ({ ...prev, isEmailAvailable: isAvailable }));
    } else {
      setForm(prev => ({ ...prev, isEmailAvailable: false }));
    }
  }, [email, isValid, isAvailable, setForm]);

  const handleChange = (e) => {
    setEmail(e.target.value);
    onChange({ target: { name: "email_address", value: e.target.value } });
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium mb-2">Email Address</label>
      <div className="relative">
        <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
        <input
          type="email"
          name="email_address"
          value={email}
          onChange={handleChange}
          className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-transparent transition-all duration-300"
          required
        />
        {loading ? (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
            Checking...
          </div>
        ) : showEmailWarning && isValid && (
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
            {isAvailable === true ? (
              <CheckCircle className="text-green-500 w-5 h-5" />
            ) : isAvailable === false ? (
              <XCircle className="text-red-500 w-5 h-5" />
            ) : email.length >= 1 && (
              <AlertCircle className="text-yellow-500 w-5 h-5" />
            )}
          </div>
        )}
      </div>

      {showEmailWarning && !isValid && email.length > 0 && (
        <p className="text-red-500 text-sm mt-1">Invalid email format.</p>
      )}

      {showEmailWarning && isValid && isAvailable === false && (
        <p className="text-red-500 text-sm mt-1">
          This email is already in use. You are registered already.
        </p>
      )}

      {email.length >= 1 && showEmailWarning && isValid && isAvailable === null && !loading && (
        <p className="text-yellow-500 text-sm mt-1">
          Unable to verify email. Please check your internet connection.
        </p>
      )}
    </div>
  );
};

// -----------------------------------------
// checkEmailAvailability (utility function)
// -----------------------------------------
async function checkEmailAvailability(email) {
  const endpoint = 'https://tsoministries.com/wp-json/wp/v2/thp';
  let page = 1;
  let emailExists = false;

  try {
    while (true) {
      const response = await fetch(`${endpoint}?per_page=100&page=${page}&_fields=id,email_address`);

      if (!response.ok) {
        // If 400 and page > 1, assume we've reached the end
        if (response.status === 400 && page > 1) {
          break;
        }
        throw new Error(`Error fetching page ${page}`);
      }

      const data = await response.json();

      if (!Array.isArray(data) || data.length === 0) {
        break;
      }

      for (const item of data) {
        if (item.email_address && item.email_address.toLowerCase() === email.toLowerCase()) {
          emailExists = true;
          break;
        }
      }

      if (emailExists || data.length < 100) {
        break;
      }

      page++;
    }

    return !emailExists; // true = available
  } catch (error) {
    console.error('Failed to check email v2:', error);
    return null;
  }
}